import { Component, Input, inject } from '@angular/core';

import { BaseDetailPage } from 'src/app/@shared/base-detail-page';
import { DatasetFormCompleteStatus } from 'src/app/@shared/form/base-form.component';
import { HideSplash } from 'src/app/@shared/hide-splash.decorator';
import { SetStatusBar } from 'src/app/@shared/status-bar.decorator';
import { ToastService } from 'src/app/@core/toast.service';
import { UserModel } from 'src/app/user/@shared/user.model';

@HideSplash()
@SetStatusBar()
@Component({
  selector: 'page-user-edit',
  standalone: false,
  styleUrls: ['./user-edit.page.scss'],
  templateUrl: './user-edit.page.html',
})
export class UserEditPage extends BaseDetailPage<UserModel> {
  @Input() public item: UserModel;

  public readonly pageTrackName = 'UserEditPage';

  public isEditMode: boolean;

  protected isStaticPage: boolean = true;

  private toastService = inject(ToastService);

  public onProcessCompleted(processCompleted: DatasetFormCompleteStatus): void {
    switch (processCompleted) {
      case 'submitted':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_SUCCESS.MESSAGE')).catch();
        this.back().catch();
        break;

      case 'error':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_ERROR.MESSAGE'), {
          color: 'danger',
        }).catch();
        break;

      default:
        this.back().catch();
        break;
    }
  }

  public async back(): Promise<void> {
    await this.modalController.dismiss();

    return Promise.resolve();
  }

  protected protoOnInit(): void {
    this.isEditMode = !!this.item?.id;
  }
}
